/* src/app/warehousing/pages/storage-rates-edit/storage-rates-edit.component.scss */
/*# sourceMappingURL=storage-rates-edit.component.css.map */
